import(/* webpackMode: "eager" */ "/app/main/app/[locale]/project/blox/page.tsx");
